import React, { useContext, useEffect, useState } from "react";
import { RxDashboard } from "react-icons/rx";
import s from "./sidebar.module.css";
import { FiUsers } from "react-icons/fi";
import { MdOutlineArticle, MdEvent } from "react-icons/md";
import { RiCommunityLine } from "react-icons/ri";
import { AiOutlineUsergroupAdd } from "react-icons/ai";
import { SiOpenbadges } from "react-icons/si";
import { MdOutlineAdminPanelSettings } from "react-icons/md";
import { PiTagBold } from "react-icons/pi";
import { PiFlagBannerBold } from "react-icons/pi";
import { MdLiveTv } from "react-icons/md";
import { IoLibraryOutline } from "react-icons/io5";
import { MdOutlineFeaturedPlayList } from "react-icons/md";
import { AiOutlineDatabase } from "react-icons/ai";
import logo from "../../assets/icons/digibhakti-icon-new.png";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../App";
import Cookies from "js-cookie";

const Sidebar = ({ open }) => {
  const { state } = useContext(UserContext);
  const [PermissionField, setPermissionField] = useState();
  useEffect(() => {
    const restorePermission = Cookies.get("permission");
    console.log(restorePermission, " this is the restore permission");
    if (restorePermission) {
      setPermissionField(restorePermission);
    } else {
      setPermissionField(state?.loginData?.admin?.access_tabs);
    }
    // setPermissionField(
    //   state?.loginData?.admin?.access_tabs || restorePermission
    // );
  }, [state]);
  const navigate = useNavigate();
  const [menuItems, setmenuItems] = useState([
    {
      title: " Dashboard",
      icons: <RxDashboard size={20} />,
      navigate: "dashboard",
      show: false,
      subItems: [],
      permission: "dashboard",
    },

    {
      title: " Users",
      icons: <FiUsers size={20} />,
      navigate: "users",
      show: false,
      subItems: [],
      permission: "users",
    },
    {
      title: "Live Darshan",
      icons: <MdLiveTv size={20} />,
      navigate: "live-darshans",
      show: false,
      subItems: [],
      permission: "liveDarshan",
    },
    {
      title: "Library media",
      icons: <IoLibraryOutline size={20} />,
      navigate: "library-media",
      show: false,
      subItems: [],
      permission: "libraryMedia",
    },
    {
      title: "Media Category",
      icons: <MdEvent size={20} />,
      navigate: "category-list",
      show: false,
      subItems: [],
      permission: "mediaCategory",
    },
    {
      title: "Banner",
      icons: <PiFlagBannerBold size={20} />,
      navigate: "banner-list",
      show: false,
      subItems: [],
      permission: "banner",
    },
    {
      title: "Feature Media",
      icons: <MdOutlineFeaturedPlayList size={20} />,
      navigate: "feature-list",
      show: false,
      suItems: [],
      permission: "featureMedia",
    },
    {
      title: "Tags",
      icons: <PiTagBold size={20} />,
      navigate: "tag-list",
      show: false,
      subItems: [],
      permission: "tags",
    },
    {
      title: "App Data",
      icons: <AiOutlineDatabase size={20} />,
      navigate: "app-data",
      show: false,
      subItems: [],
      permission: "appData",
    },

    {
      title: "Blogs",
      icons: <MdEvent size={20} />,
      navigate: "blog-list",
      show: false,
      subItems: [],
      permission: "blogs",
    },
    {
      title: "Puja",
      icons: <MdEvent size={20} />,
      navigate: "event-list",
      show: false,
      subItems: [],
      permission: "puja",
    },
    {
      title: "New Puja List",
      icons: <MdEvent size={20} />,
      navigate: "new-puja-list",
      show: false,
      subItems: [],
      permission: "newPuja",
    },
    {
      title: "Festivals",
      icons: <MdEvent size={20} />,
      navigate: "holiday-list",
      show: false,
      subItems: [],
      permission: "festivals",
    },
    {
      title: "Reviews",
      icons: <MdEvent size={20} />,
      navigate: "review-list",
      show: false,
      subItems: [],
      permission: "reviews",
    },
    {
      title: "Certificate",
      icons: <MdEvent size={20} />,
      navigate: "upload-certificate",
      show: false,
      subItems: [],
      permission: "certificate",
    },
    // {
    //   title: "New Certificate",
    //   icons: <MdEvent size={20} />,
    //   navigate: "new-certificate",
    //   show: false,
    //   subItems: [],
    //   permission: "new-certificate",
    // },
    {
      title: "Subscription",
      icons: <MdEvent size={20} />,
      navigate: "subscription-list",
      show: false,
      subItems: [],
      permission: "subscription",
    },
    {
      title: "Transaction",
      icons: <MdEvent size={20} />,
      navigate: "admin-transaction",
      show: false,
      subItems: [],
      permission: "transaction",
    },
    {
      title: "Subscription Transaction",
      icons: <MdEvent size={20} />,
      navigate: "subscription-transaction",
      show: false,
      subItems: [],
      permission: "subscriptionTransaction",
    },
     {
      title: " New Transaction",
      icons: <MdEvent size={20} />,
      navigate: "new-transaction-list",
      show: false,
      subItems: [],
      permission: "new-transaction-list",
    },
     {
      title: " Notification",
      icons: <MdEvent size={20} />,
      navigate: "notification",
      show: false,
      subItems: [],
      permission: "notification",
    },
    {
      title: "Sub Admin",
      icons: <RxDashboard size={20} />,
      navigate: "members-list",
      activeRoute: ["members-list"],
      show: false,
      subItems: [],
      permission: "members",
    },
    // {
    //   title: "Roles",
    //   icons: <GiCash size={20} />,
    //   navigate: "add-role",
    //   activeRoute: ["role-list", "add-role"],
    //   show: false,
    //   subItems: [],
    // },
  ]);
  useEffect(() => {
    if (Cookies.get("digiRole") === "subadmin") {
      // setmenuItems((prevMenuItems) =>
      //   prevMenuItems.map((item) => ({
      //     ...item,
      //     show: PermissionField[item.permission] || false, // Update `show` based on permissions
      //   }))
      // );
      setmenuItems((prevMenuItems) =>
        prevMenuItems.map((item) => ({
          ...item,
          show: PermissionField?.includes(item?.permission),
        }))
      );
    } else {
      setmenuItems((prevMenuItems) =>
        prevMenuItems.map((item) => ({
          ...item,
          show: true,
        }))
      );
    }
  }, [PermissionField]);
  return (
    <>
      <section className={s["sidebar"]}>
        <div
          style={{ display: "flex", justifyContent: "center" }}
          className={`${s["collapsed-logo"]} ${
            open ? `${s["logo-section"]}` : `${s["logo-section-hide"]}`
          }`}
        >
          <img
            src={logo}
            alt="logo"
            draggable="false"
            style={{ width: "49%" }}
          />
        </div>
        {menuItems.map(
          (data, i) =>
            data?.show && (
              <div className={s["sidebar-content"]}>
                <div
                  className={s["sidebar-item"]}
                  onClick={() => navigate(`/${data?.navigate}`)}
                >
                  <div className="sidebaricons">{data.icons}</div>
                  <div
                    className={
                      open
                        ? `${s["sidebar-title"]}`
                        : `${s["sidebar-title-hide"]}`
                    }
                  >
                    {data?.title}
                  </div>
                </div>
              </div>
            )
        )}
      </section>
    </>
  );
};
export default Sidebar;
